module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Redo-bdf76cf06c8e3e6fb5e172fa204cdef0.svg";